module.exports = __webpack_public_path__ + "static/project_reactbricks-b677c39fe7a6ef89261a98c4fb73e7a2.gif";